var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8504 14.3492L10.1254 1.29922C9.90041 0.849219 9.45041 0.699219 9.00041 0.699219C8.55041 0.699219 8.17541 0.924219 7.87541 1.29922L0.150408 14.3492C-0.374592 15.2492 0.225408 16.2992 1.27541 16.2992H16.7254C17.7004 16.3742 18.3004 15.2492 17.8504 14.3492ZM16.8754 15.1742C16.8004 15.2492 16.7254 15.2492 16.7254 15.2492H1.27541C1.27541 15.2492 1.20041 15.2492 1.12541 15.1742C1.12541 15.0992 1.05041 15.0242 1.12541 14.9492L8.85041 1.82422C8.85041 1.82422 8.92541 1.74922 9.00041 1.74922C9.07541 1.74922 9.15041 1.82422 9.15041 1.82422L16.8754 14.9492C16.8754 15.0242 16.8754 15.0992 16.8754 15.1742Z",
    fill: "#2362A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00019 10.75C9.30019 10.75 9.6002 10.525 9.6002 10.225L9.97519 6.25C10.0502 5.65 9.60019 5.125 8.92519 5.125C8.25019 5.125 7.9502 5.65 7.9502 6.25L8.3252 10.225C8.4002 10.525 8.70019 10.75 9.00019 10.75Z",
    fill: "#2362A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.125C9.62132 14.125 10.125 13.6213 10.125 13C10.125 12.3787 9.62132 11.875 9 11.875C8.37868 11.875 7.875 12.3787 7.875 13C7.875 13.6213 8.37868 14.125 9 14.125Z",
    fill: "#2362A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportWarning);
export default __webpack_public_path__ + "static/media/import_warning.dca17e7eeadd6edbd12b23ee0c8ee639.svg";
export { ForwardRef as ReactComponent };